'use client';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { selectAuth } from '@app/store/auth/authSlice';
import { selectActiveOrganization, selectActiveProject } from '@app/store/active/slice';

export default function ChatwootHandler() {
    const user = useSelector(selectAuth);
    const organization = useSelector(selectActiveOrganization);
    const project = useSelector(selectActiveProject);
    const router = useRouter();

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const setUserIfReady = () => {
            if (!window.$chatwoot || !user?.userId) return;

            window.$chatwoot.setUser(user.userId, {
                email: user.email,
                name: user.name,
                identifier_hash: user.identifierHash
            });

            window.addEventListener('chatwoot:on-message', (e: any) => {
                window.$chatwoot.setConversationCustomAttributes({
                    organization: organization?.name || 'Unknown Organization',
                    project: router.query.projectId != undefined ? project!.projectName : ''
                });
            });
        };

        if ((window as any).$chatwoot?.hasLoaded) setUserIfReady();
        window.addEventListener('chatwoot:ready', setUserIfReady);

        return () => window.removeEventListener('chatwoot:ready', setUserIfReady);
    }, [user?.userId, organization?.name, project?.projectName]);

    // Toggle chat bubble visibility
    useEffect(() => {
        if (typeof document === 'undefined') return;

        const isAuthPage = router.pathname === '/' || router.pathname.startsWith('/login');
        const shouldHide = !user?.userId || isAuthPage;

        const root = document.documentElement;
        root.classList.toggle('hide-chatwoot', shouldHide);

        const nodes = document.querySelectorAll<HTMLElement>('#chatwoot-widget, .woot-widget-holder, .woot-widget-bubble, iframe[id^="chatwoot"], iframe[src*="/widget"]');
        nodes.forEach((n) => (n.style.display = shouldHide ? 'none' : 'block'));
    }, [user?.userId, router.pathname]);

    return null;
}
